import { ChannelType, PlatformType } from '../types';

class EnvHelper {
  public platform = PlatformType.UNKNOWN;
  public channel = ChannelType.UNKNOWN;
  public isIos = false;
  public isAndroid = false;

  public constructor() {
    if (typeof window !== 'undefined') {
      this.platform = this.initPlatform();
      this.channel = this.initChannel();
      this.initAppData();
    }
  }

  get isQQ() {
    return this.platform === PlatformType.QQ;
  }
  get isWX() {
    return this.platform === PlatformType.WX;
  }
  get isTenvideo() {
    return this.platform === PlatformType.TENVIDEO;
  }
  get isWeishi() {
    return this.platform === PlatformType.WEISHI;
  }
  get isSports() {
    return this.platform === PlatformType.SPORTS;
  }
  get isYYB() {
    return this.platform === PlatformType.YYB;
  }

  /**
   * 获得当前的运行环境
   */
  private initPlatform() {
    const configs = [
      {
        ua: /MicroMessenger/,
        platform: PlatformType.WX,
      },
      {
        ua: /QQ[\s/]*(\d+(\.\d+)*)/i,
        platform: PlatformType.QQ,
      },
      {
        ua: /_WEISHI_/,
        platform: PlatformType.WEISHI,
      },
      {
        ua: /QQLiveBrowser|QQLiveHDBrowser/,
        platform: PlatformType.TENVIDEO,
      },
      {
        ua: /qqsports/i,
        platform: PlatformType.SPORTS,
      },
      {
        ua: /yyb_version|qqdownloader/,
        platform: PlatformType.YYB,
      },
      {
        ua: /com.tencent.bbg?[\s/]*(\d+(\.\d+)*)/,
        platform: PlatformType.BBG,
      },
      {
        ua: /QQAC_Client/,
        platform: PlatformType.AC,
      },
      {
        ua: /miniprogram/i,
        platform: PlatformType.WX_MINI_PROGRAM,
      },
    ];

    for (const { ua, platform } of configs) {
      if (ua.test(window.navigator.userAgent)) return platform;
    }

    return PlatformType.UNKNOWN;
  }

  /**
   * 根据域名判断当前的登录渠道
   */
  private initChannel() {
    const configs = [
      {
        host: 'iwan.qq.com',
        channel: ChannelType.TENVIDEO,
      },
      {
        host: 'film.video.qq.com', // vip会员活动场景
        channel: ChannelType.TENVIDEO,
      },
      {
        host: 'weishi.qq.com',
        channel: ChannelType.WEISHI,
      },
      {
        host: 'sports.qq.com',
        channel: ChannelType.SPORTS,
      },
      {
        host: 'yyb.qq.com',
        channel: ChannelType.YYB,
      },
      {
        host: 'ac.qq.com',
        channel: ChannelType.AC,
      },
    ];

    for (const { host, channel } of configs) {
      const { hostname } = location;
      if (hostname.indexOf(host) > -1) return channel;
    }

    return ChannelType.UNKNOWN;
  }

  private initAppData() {
    const ua = navigator.userAgent;

    this.isIos = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/.test(ua);
    this.isAndroid = /\bAndroid ([^;]+)/.test(ua);
  }
}

export const envHelper = new EnvHelper();
